import { render, staticRenderFns } from "./NonConformityPreventativeMeasure.vue?vue&type=template&id=8cf5d462&scoped=true&"
import script from "./NonConformityPreventativeMeasure.vue?vue&type=script&lang=js&"
export * from "./NonConformityPreventativeMeasure.vue?vue&type=script&lang=js&"
import style0 from "./NonConformityPreventativeMeasure.vue?vue&type=style&index=0&id=8cf5d462&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf5d462",
  null
  
)

export default component.exports